export * from "entries/constructors/classic-test/views/components/image-answer/image";
export * from "entries/constructors/classic-test/views/components/image-answer/image-answer.module.sass";
